/* eslint-disable @typescript-eslint/no-empty-function */
import { Region } from 'interfaces/Region'
import { SchoolType } from 'interfaces/SchoolType'
import { useEffect, useRef, useState } from 'react'
import { trackPromise } from 'react-promise-tracker'
import SchoolTypeService from 'services/SchoolTypeService'
import { ApiError } from 'services/ApiService'
import _useTranslation from 'lib/hooks/_useTranslation'
import { Form } from '@unform/web'
import Stack from 'components/elements/Stack'
import { FormHandles } from '@unform/core'
import Select from 'components/elements/Inputs/Select'
import SelectMultiple from 'components/elements/Inputs/SelectMultiple'

interface Props {
    selectedRegion: Region | null
    toggleSchoolTypeSelect: (schoolType: SchoolType) => void
    changeDefaultSchoolTypes?: (schoolType: SchoolType[]) => void
    initialSchoolTypes?: SchoolType[]
    limitToOneSelectedItem?: boolean
    isDarkTheme?: boolean
}
const GradeSelectionSchoolTypes = ({
    selectedRegion,
    toggleSchoolTypeSelect,
    initialSchoolTypes,
    changeDefaultSchoolTypes,
    limitToOneSelectedItem,
    isDarkTheme,
}: Props) => {
    const [initialSchoolTypeData, setInitialSchoolTypeData] = useState<
        {
            label: string
            data: SchoolType
        }[]
    >([])

    const [schoolTypeOptions, setSchoolTypeOptions] = useState<
        {
            label: string
            data: SchoolType
        }[]
    >()
    const { t } = _useTranslation('knows')
    const { t: tCommon } = _useTranslation('common')
    const formRef = useRef<FormHandles>(null)

    useEffect(() => {
        if (!selectedRegion) return

        trackPromise(
            SchoolTypeService.listSchoolTypesByRegion(selectedRegion.id)
                .then((schoolTypes) => {
                    const schoolTypesOptions = schoolTypes

                    const options = schoolTypes.map((type) => ({
                        label: type.name,
                        data: type,
                    }))

                    setSchoolTypeOptions(options)

                    if (initialSchoolTypes && initialSchoolTypes?.length > 0) {
                        setInitialSchoolTypeData(
                            initialSchoolTypes.map((type) => ({
                                label: type.name,
                                data: type,
                            }))
                        )

                        if (!changeDefaultSchoolTypes) return

                        const selectedSchoolTypesFromKnow = schoolTypesOptions.filter((schoolType) =>
                            initialSchoolTypes.find((knowSchoolType) => knowSchoolType.id === schoolType.id)
                        )

                        !!selectedSchoolTypesFromKnow && changeDefaultSchoolTypes(selectedSchoolTypesFromKnow)
                    } else {
                        options[0] && setInitialSchoolTypeData([options[0]])
                        schoolTypesOptions[0] &&
                            changeDefaultSchoolTypes &&
                            changeDefaultSchoolTypes([schoolTypesOptions[0]])
                    }
                })
                .catch((error) => {
                    if (error instanceof ApiError) {
                        error.handleUnknownError(tCommon, 'schoolTypes.list')
                    } else {
                        throw error
                    }
                })
        )
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedRegion, tCommon])

    return (
        <>
            {schoolTypeOptions && schoolTypeOptions.length > 1 ? (
                <>
                    <Stack>
                        <Form
                            ref={formRef}
                            onSubmit={() => {}}
                            initialData={{
                                schoolTypes: limitToOneSelectedItem ? initialSchoolTypeData[0] : initialSchoolTypeData,
                            }}
                        >
                            {limitToOneSelectedItem ? (
                                <Select
                                    name="schoolTypes"
                                    options={schoolTypeOptions}
                                    placeholder={t('knows/createDetailsPageKnowSchoolTypeLabel')}
                                    onUpdate={toggleSchoolTypeSelect}
                                    darkTheme={isDarkTheme}
                                />
                            ) : (
                                <SelectMultiple
                                    name="schoolTypes"
                                    options={schoolTypeOptions}
                                    placeholder={t('knows/createDetailsPageKnowSchoolTypeLabel')}
                                    onUpdate={toggleSchoolTypeSelect}
                                    dataCy="schoolTypes-fake"
                                    darkTheme={isDarkTheme}
                                    isDarkTheme={isDarkTheme}
                                />
                            )}
                        </Form>
                    </Stack>
                </>
            ) : null}
        </>
    )
}

export default GradeSelectionSchoolTypes
